




















































































































import { CorbeilleApi } from "../api/CorbeilleApi";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import CorbeilleListFilters from "./CorbeilleListPartials/CorbeilleListFilters.vue";
import CorbeilleDetailModal from "./CorbeilleDetailModal.vue";

export default {
    name: "CorbeilleList",
    components: {
        Pagination,
        PerPage,
        CorbeilleListFilters,
        CorbeilleDetailModal,
    },
    data() {
        return {
            elements: [],
            CorbeilleApi: new CorbeilleApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            types: [],
            auteurs: [],
            retentionDays: null,
            detailModal: {
                element: null,
                show: false,
            },
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                sort: self.sort,
            };

            params = _.assign(params, self.filters);
            self.loading = true;

            return self.CorbeilleApi.getAll(params)
                .then(function (response) {
                    let { data, metadata, paginator } = response;

                    self.elements = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;

                    if (!_.isEqual(self.types, metadata.types)) {
                        self.types = metadata.types;
                    }
                    if (!_.isEqual(self.auteurs, metadata.auteurs)) {
                        self.auteurs = metadata.auteurs;
                    }
                    self.retentionDays = metadata.retention_days;
                })
                .catch(function () {
                    self.elements = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        getElements() {
            return this.loadPage(this.currentPage);
        },
        updateFilters(filters): void {
            this.filters = filters;
        },
        updateSort(sort): void {
            this.sort = sort;
        },
        // Détail
        showDetail(element) {
            let self = this;
            // Le détail porte l'aperçu, absent de la liste.
            self.CorbeilleApi.get(element.id)
                .then(function (detail) {
                    self.detailModal.element = detail;
                    self.detailModal.show = true;
                })
                .catch(function (error) {
                    self.onActionError(error, "Cet élément est inaccessible.");
                });
        },
        closeDetail() {
            this.detailModal.show = false;
            this.detailModal.element = null;
        },
        // Actions
        restaurer(element) {
            let self = this;
            self.confirm(
                "Restaurer cet élément ?",
                "« " + element.libelle + " » reprendra sa place dans son module.",
                "btn btn-success"
            ).then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                self.CorbeilleApi.restore(element.id)
                    .then(function () {
                        self.closeDetail();
                        self.getElements();
                        swal("L'élément a bien été restauré !", "", "success");
                    })
                    .catch(function (error) {
                        self.onActionError(
                            error,
                            "Cet élément ne peut pas être restauré."
                        );
                    });
            });
        },
        supprimer(element) {
            let self = this;
            self.confirm(
                "Supprimer définitivement cet élément ?",
                "« " + element.libelle + " » ne pourra plus être restauré.",
                "btn btn-danger"
            ).then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                self.CorbeilleApi.delete(element.id)
                    .then(function () {
                        self.closeDetail();
                        self.getElements();
                        swal(
                            "L'élément a été supprimé définitivement !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        self.onActionError(
                            error,
                            "Cet élément ne peut pas être supprimé définitivement."
                        );
                    });
            });
        },
        /**
         * Demande de confirmation : résout à false si l'utilisateur annule
         * (sweetalert rejette alors sa promesse).
         */
        confirm(title, text, confirmButtonClass): Promise<boolean> {
            return swal({
                title: title,
                text: text,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: confirmButtonClass,
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            }).then(
                function () {
                    return true;
                },
                function () {
                    return false;
                }
            );
        },
        /**
         * Refus de l'API : message du serveur (422 du module, 404 d'un
         * élément qui a quitté la corbeille entre-temps), puis liste à jour.
         */
        onActionError(error, defaultMessage): void {
            let data = error && error.response ? error.response.data : null;
            let message =
                (data && data.message) ||
                (data && data.error && data.error.message) ||
                defaultMessage;

            this.closeDetail();
            this.getElements();

            // Client absorbé par une fusion : lien vers le Client conservé.
            if (data && data.client_conserve_id) {
                swal({
                    title: "Restauration impossible",
                    // Le message porte le nom du client : échappé.
                    html:
                        "<p>" +
                        _.escape(message) +
                        '</p><a href="#/app/client/' +
                        Number(data.client_conserve_id) +
                        '">Ouvrir le client conservé</a>',
                    type: "error",
                });
                return;
            }

            swal(message, "", "error");
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
